export function requestedActionsNeedExecution(
  requestedActions: readonly string[],
  appliedActions: readonly string[],
  sceneMutated: boolean,
): boolean {
  return requestedActions.length > 0 && appliedActions.length === 0 && !sceneMutated;
}
